import { assert, Test } from "oc-e2e-testrunner";
import { assertWarnungen, createElement, normalizeWhitespace, resetArrangement } from "./utils";

export default {
  name: "TestDreifachtor",
};

export const testDreifachtorTorpfostenset: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 6;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  const s = agt.segmente[0];
  const doppeltor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Doppeltor_Easy"),
  });
  const einfachtor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });
  s.setX(einfachtor, 1, breite);
  s.setX(doppeltor, 1, s.getX(einfachtor, 0));
  agt.update3d();
  // Bestellliste enthält den Artikel erst nach dem zweiten update3d
  agt.update3d();
  APP.dirty();
  assert.isTrue(
    agt.bestellliste.some((e) => e.Artikelnummer.startsWith("2625")),
    "Es soll einen Dreifach-Torpfostenset in der Stückliste geben!"
  );
  assert.equals(
    "Dreifachtor 177 x 180 cm + 178 x 180 cm",
    normalizeWhitespace(agt.baugruppen[0][0].MassOrBauseitsTag),
    "Das Maß muss ausgewiesen sein"
  );
};

export const testDreifachtorAuswahlwerteAngleichenEinzeltorseite: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  const breite = 6;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  const s = agt.segmente[0];
  const doppeltor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Doppeltor_Easy"),
  });
  const einfachtor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });
  s.setX(einfachtor, 1, breite);
  s.setX(doppeltor, 1, s.getX(einfachtor, 0));
  agt.update3d();

  // zuvor zur Sicherheit die Standards prüfen

  const standardPfosten = {
    type: "Pfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    pfostenfarbeAuswahlwertIndividualisiert: false,
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    bodenbefestigungAuswahlwertIndividualisiert: false,
    elementhalterAuswahlwertIndividualisiert: false,
    pfostenartAuswahlwert: "Metalltorpfosten",
    verbundankerAuswahlwert: "Verbundanker-Set_mit",
    ummantelungAuswahlwert: "Ummantelung_ohne",
    ankerInnen: false,
    ausgleichGefälle: false,
    // Dreifachtorpfosten müssen einbetoniert sein
    pfostenAuswahlwert: "Torpfosten Einbetonieren Anthrazit",
  };
  const standardElement = {
    type: "Element",
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Anthrazit",
    gehflügelAuswahlwert: "Gehflügel_links",
    drückerAuswahlwert: "Drücker_Knauf_edelstahl",
    profilzylinderAuswahlwert: "Profilzylinder_mit",
    rahmenAuswahlwert: "Tor_Rahmen_Anthrazit",
    öffnungAuswahlwert: "Öffnung_nach_innen",
    anschlagAuswahlwert: "Anschlag_links",
    schieberichtungAuswahlwert: "Schieberichtung_links",
    schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
    füllungsseiteAuswahlwert: "Füllungsseite_B",
    anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
    profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
    profilPosition: 10,
    profilPositionIndividualisiert: false,
    profilAuswahlwertIndividualisiert: false,
    showProfil: null,
    detailSerie: "SYSTEM WPC CLASSIC",
  };
  assert.deepEqualsPicked(
    [
      standardPfosten,
      { ...standardElement, form: "Doppeltor" },
      standardPfosten,
      { ...standardElement, form: "Einzeltor" },
      standardPfosten,
    ],
    s.getPartsAndPfostenWithoutEmpties().map((p) => p.toJSON())
  );

  // jetzt neue Werte nur auf einem Tor setzen, sollen sich auch beim andern wiederspiegeln

  const newElement = {
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
    rahmenAuswahlwert: "Tor_Rahmen_Weiss",
    profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
    showProfil: true,
    profilPosition: 10,
    profilleisteAuswahlwert: "Dekor_Adapter_weiss",
    füllungsseiteAuswahlwert: "Füllungsseite_A",
    drückerAuswahlwert: "Drücker_Knauf_weiß",
    profilzylinderAuswahlwert: "Profilzylinder_ohne",
  };
  APP.arrangement.setSelectedObjects([einfachtor]);
  agt.update3d();
  einfachtor.setJsonPartial(newElement);
  agt.update3d();
  const newPfosten = {
    pfostenfarbeAuswahlwert: "Weiß",
  };
  APP.arrangement.setSelectedObjects([einfachtor.pfostenLinks]);
  agt.update3d();
  einfachtor.pfostenLinks.setJsonPartial(newPfosten);
  agt.update3d();
  assert.deepEqualsPicked(
    [
      {
        ...newPfosten,
      },
      {
        ...standardElement,
        ...newElement,
        form: "Doppeltor",
      },
      {
        ...newPfosten,
      },
      {
        ...standardElement,
        ...newElement,
        form: "Einzeltor",
      },
      {
        ...newPfosten,
      },
    ],
    s.getPartsAndPfostenWithoutEmpties().map((p) => p.toJSON())
  );
  APP.dirty();
};

export const testDreifachtorAuswahlwerteAngleichenDoppeltorseite: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 6;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  const s = agt.segmente[0];
  const doppeltor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Doppeltor_Easy"),
  });
  const einfachtor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });
  s.setX(einfachtor, 1, breite);
  s.setX(doppeltor, 1, s.getX(einfachtor, 0));
  agt.update3d();

  // jetzt neue Werte nur auf einem Tor setzen, sollen sich auch beim andern wiederspiegeln

  const newElement = {
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
    rahmenAuswahlwert: "Tor_Rahmen_Weiss",
    profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
    showProfil: true,
    profilPosition: 9,
    profilleisteAuswahlwert: "Dekor_Adapter_weiss",
    füllungsseiteAuswahlwert: "Füllungsseite_A",
    drückerAuswahlwert: "Drücker_Knauf_weiß",
    profilzylinderAuswahlwert: "Profilzylinder_ohne",
  };
  APP.arrangement.setSelectedObjects([doppeltor]);
  agt.update3d();
  doppeltor.setJsonPartial(newElement);
  agt.update3d();
  const newPfosten = {
    pfostenfarbeAuswahlwert: "Weiß",
  };
  APP.arrangement.setSelectedObjects([doppeltor.pfostenRechts]);
  agt.update3d();
  doppeltor.pfostenRechts.setJsonPartial(newPfosten);
  agt.update3d();
  assert.deepEqualsPicked(
    [
      {
        ...newPfosten,
      },
      {
        ...newElement,
        form: "Doppeltor",
      },
      {
        ...newPfosten,
      },
      {
        ...newElement,
        form: "Einzeltor",
      },
      {
        ...newPfosten,
      },
    ],
    s.getPartsAndPfostenWithoutEmpties().map((p) => p.toJSON())
  );
  APP.dirty();
};

export const testDreifachtorWechselDoppeltorAufJumboWPC: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 10;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  const s = agt.segmente[0];
  const doppeltor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Doppeltor_Easy"),
  });
  const einfachtor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });
  s.setX(einfachtor, 1, breite);
  s.setX(doppeltor, 1, s.getX(einfachtor, 0));
  agt.update3d();
  const dumpElemente = () =>
    agt.segmente[0]
      .getElemente()
      .map((e) => ({ id: e.id, mass: e.massAuswahlwert.Key, füllung: e.füllungAuswahlwert.Key }));
  const elementeDump = dumpElemente();
  APP.arrangement.serie = APP.richMetadata.findSerie("JUMBO WPC");
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("JUMBO WPC ALU Grau-Grau");
  agt.changeZaunElemente({ füllungAuswahlwert }, [doppeltor]);
  agt.update3d();
  elementeDump.forEach((e) => (e.füllung = "JUMBO WPC ALU Grau-Grau"));
  assert.deepEquals(elementeDump, dumpElemente());
  assertWarnungen(agt, []);
};
